import { Avatar, Card, Col, Layout, Row, Image } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import CampaignSidebar from "./sidebar";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const CampaignLayout = ({
  children,
  campaignId,
}: {
  children: ReactElement;
  campaignId: string;
}): ReactElement => {
  const { campaignInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                size="small"
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content">
                      <div className="shop-banner">
                        <Image
                          src={getImgUrl(campaignInfo?.banner)}
                          alt={campaignInfo?.name}
                          className="rounded"
                        />
                      </div>

                      <div className="shop-image-content">
                        <div className="shop-logo">
                          <Avatar
                            size={105}
                            src={getImgUrl(campaignInfo?.bannerWeb)}
                          />
                        </div>
                        <div className="body">
                          <h4>{campaignInfo?.name?.toUpperCase()}</h4>
                          <div className="mb-4">
                            <span className="radius-btn active-btn">
                              {campaignInfo?.type?.replace("_", " ")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                <CampaignSidebar campaignId={campaignId} />
              </Card>
            </Col>
            <Col span={18}>
              <Card
                size="small"
                className="product-information-show-tab-wrapper"
              >
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

CampaignLayout.propType = {
  children: PropTypes.element,
};

export default CampaignLayout;
